import { configureStore } from '@reduxjs/toolkit';

import instanceReducer from './Instance/Reducer';
import instancesReducer from './Instances/Reducer';
import themeReducer from './reducers/themeReducer';
import jobEditorReducer from './reducers/jobEditorReducer';
import menuJobIdReducer from './reducers/menuJobIdReducer';
import { orgMembersReducer } from './reducers/orgMembersReducer';
import { kanbanBoardReducer } from './reducers/kanbanBoardReducer';

export const store = configureStore({
  reducer: {
    instances: instancesReducer,
    instance: instanceReducer,
    theme: themeReducer,
    jobEditor: jobEditorReducer,
    menuJobId: menuJobIdReducer,
    kanbanBoard: kanbanBoardReducer,
    orgMembers: orgMembersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export * from './Actions/themeActions';
// Export theme-related functionality
export * from './reducers/themeReducer'; 

// Export job editor-related functionality
export * from './Actions/jobEditorActions';
export * from './reducers/jobEditorReducer';
